import { timeFormat } from '@/utils'

export const baseConfig = function () {
  return [
    {
      type: 'DatePicker',
      title: '舆情发现日期',
      [$field]: 'discoverTime',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '发生日期',
      [$field]: 'postDate',
      rules: ['']
    },
    {
      title: '舆情记录人',
      [$field]: 'createUserName',
      readOnly: true,
      rules: ['']
    },
    {
      title: '舆情标题',
      [$field]: 'publicOpinionTitle',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '舆情记录时间',
      [$field]: 'createDate',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'Checkbox',
      title: '舆情类型',
      [$field]: 'opinionTypes',
      colSpan: 24,
      optionList: this.dictMap['BOE62'],
      rules: ['']
    },
    {
      type: 'MultipleCheckbox',
      title: '舆情来源',
      [$field]: 'opinionSources',
      childKey: 'postBars',
      colSpan: 24,
      optionList: this.dictMap['BOE82'],
      childOptionList: this.dictMap['postBar'],
      rules: ['']
    },
    {
      type: 'Radio',
      title: '舆情等级',
      [$field]: 'opinionLevels',
      colSpan: 24,
      optionList: this.dictMap['BOE48'],
      rules: ['']
    },
    {
      title: '舆情关键词',
      [$field]: 'publicOpinionAntistop',
      colSpan: 24,
      rules: ['']
    },
    {
      type: 'universalTree',
      props: {
        modalTitle: '选择涉及组织',
        treeParams: {
          orgId: sessionStorage.getItem('listOrgId') || ''
        },
        isSingle: false,
        map: {
          name: 'involveOrgName'
        }
      },
      title: '舆情涉及地区或组织',
      [$field]: 'publicOpinionOrgIds',
      colSpan: 24,
      rules: [''],
      optionList: []
    },
    {
      title: '舆情说明',
      [$field]: 'publicOpinionExplain',
      type: 'textarea',
      props: {
        maxlength: 500
      },
      rules: [''],
      colSpan: 24
    },
    {
      type: 'FileUpload',
      colSpan: 24,
      title: '舆情相关附件',
      [$field]: 'uploadFile',
      props: {
        data: {
          groupId: ''
        },
        multiple: true,
        isShowFileList: true,
        formatText: '支持word、pdf格式，附件大小不超过5M。请勿上传违反国家法律法规或不宜网络公开的资料。',
        accept: '.docx,.doc,.pdf'
      },
      rules: []
    }
  ]
}
export const handleConfig = function () {
  return [
    {
      type: 'FileUpload',
      title: '附件资料',
      colSpan: 24,
      [$field]: 'handleUploadFile',
      readOnly: true,
      props: {
        data: {
          groupId: ''
        },
        multiple: true,
        isShowFileList: true,
        formatText: '支持word、pdf格式，附件大小不超过5M。请勿上传违反国家法律法规或不宜网络公开的资料。',
        accept: '.docx,.doc,.pdf'
      },
      rules: ['']
    },
    {
      type: 'textarea',
      title: '舆情处理结果说明',
      colSpan: 24,
      [$field]: 'processContent',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'Input',
      title: '舆情处理结果记录人',
      [$field]: 'userName',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '舆情处理结果记录时间',
      readOnly: true,
      [$field]: 'createDate',
      rules: ['']
    },
    {
      type: 'Input',
      title: '处理结果记录人所在组织',
      readOnly: true,
      [$field]: 'orgName',
      rules: ['']
    }
  ]
}
export const examineResultConfig = function () {
  return [
    {
      type: 'Radio',
      title: '舆情处理审核结果',
      [$field]: 'processState',
      optionList: [{
        label: '审核通过',
        value: '3'
      }, {
        label: '驳回重新办理',
        value: '2'
      }],
      rules: ['required']
    },
    // {
    //   type: 'Radio',
    //   title: '是否公开舆情处理方案',
    //   [$field]: 'isShare',
    //   optionList: this.dictMap['KZ41'],
    //   rules: ['']
    // },
    {
      type: 'textarea',
      title: '舆情处理审核意见',
      [$field]: 'auditContent',
      colSpan: 24,
      rules: ['required']
    },
    {
      title: '舆情处理审核人',
      [$field]: 'auditUserName',
      readOnly: true,
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '舆情处理审核时间',
      [$field]: 'auditTime',
      readOnly: true,
      rules: ['']
    },
    {
      title: '舆情处理审核人所在组织',
      [$field]: 'auditOrgName',
      readOnly: true,
      rules: ['']
    }
  ]
}
export const resultTableConfig = function () {
  return [
    {
      title: '办理序号',
      [$field]: 'index',
      type: 'index',
      width: 80
    },
    {
      title: '步骤',
      [$field]: 'nodeName'
    },
    {
      title: '办理人',
      [$field]: 'handlerName'
    },
    {
      title: '办理人组织',
      [$field]: 'handleOrgName'
    },
    {
      title: '处理时间',
      [$field]: 'handleTime',
      render: (h, {row}) => {
        return h('span', timeFormat(row.handleTime, 'yyyy-MM-dd HH:mm:ss'))
      }
    },
    {
      title: '处理结果',
      [$field]: 'handleResult'
    }
  ]
}